const getDefaultState = () => {
  return {
    vehicle: {
      licensePlate: null,
      type: null,
      info: null
    },
    manualReportCode: null,
    manualCatalogValue: null,
    vehicleUtilization: null,
    coverage: {
      WA: null,
      CASCO: null,
      OVI: null,
      SVI: null,
      VRB: null,
      PH: null,
      VV: null,
      INVT: null
    },
    startDate: null,
    email: null,
    productModelCoverages: []
  }
}

const TYPE_YES_NO = "YES_NO";
const TYPE_TEXT = "TEXT";

export default {
  namespaced: true,
  state: {
    vehicle: {
      licensePlate: null,
      type: null,
      info: null
    },
    manualReportCode: null,
    manualCatalogValue: null,
    vehicleUtilization: null,
    coverage: {
      WA: null,
      CASCO: null,
      OVI: null,
      SVI: null,
      VRB: null,
      PH: null,
      VV: null,
      INVT: null
    },
    startDate: null,
    email: null,
    productModelCoverages: []
  },
  getters: {
    getModelCoverages(state, type) {
      return state.productModelCoverages
        .filter(coverage => coverage.type === type)
        .sort((a, b) => a.code.localeCompare(b.code));
    },
    getPostData(state) {
      let coverages = [
        { questionType: TYPE_TEXT, questionCode: "WA", answer: state.coverage.WA },
        { questionType: TYPE_YES_NO, questionCode: "BC", answer: state.coverage.CASCO === "limited" ? "y" : "n" },
        { questionType: TYPE_YES_NO, questionCode: "VC", answer: state.coverage.CASCO === "full" ? "y" : "n" },
        { questionType: TYPE_YES_NO, questionCode: "NO_CASCO", answer: state.coverage.CASCO === "none" ? "y" : "n" },
        { questionType: TYPE_YES_NO, questionCode: "SVI", answer: state.coverage.SVI },
        { questionType: TYPE_YES_NO, questionCode: "OVI", answer: state.coverage.OVI },
        { questionType: TYPE_YES_NO, questionCode: "VRB", answer: state.coverage.VRB },
        { questionType: TYPE_YES_NO, questionCode: "VV", answer: state.coverage.VV },
        { questionType: TYPE_YES_NO, questionCode: "PH", answer: state.coverage.PH }
      ];
      return {
        "licensePlate": state.vehicle.licensePlate,
        "manualReportCode": state.manualReportCode,
        "manualCatalogValueExVat": state.manualCatalogValue,
        "vehicleUtilization": state.vehicleUtilization,
        "startDate": state.startDate,
        "email": state.email,
        "coverage": coverages
      };
    }
  },
  mutations: {
    setVehicleInfo(state, value) {
      state.vehicle.licensePlate = value.licensePlate;
      state.vehicle.type = value.type;
      state.vehicle.info = value.info;
    },
    setManualReportCode(state, value) {
      state.manualReportCode = value;
    },
    setManualCatalogValue(state, value) {
      state.manualCatalogValue = value;
    },
    setVehicleUtilization(state, value) {
      state.vehicleUtilization = value;
    },
    setCoverages(state, value) {
      // Set coverage if given to set
      Object.keys(state.coverage).forEach(possibleCoverage => {
        // Set if available in value
        if (Object.prototype.hasOwnProperty.call(value, possibleCoverage)) {
          state.coverage[possibleCoverage] = value[possibleCoverage];
        }
      });
    },
    resetCoverages(state) {
      Object.keys(state.coverage).forEach(coverage => {
        if (Object.prototype.hasOwnProperty.call(state.coverage, coverage)) {
          state.coverage[coverage] = null;
        }
      });
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setStartDate(state, value) {
      state.startDate = value;
    },
    setEmail(state, value) {
      state.email = value;
    },
    setProductModelCoverages(state, value) {
      state.productModelCoverages = [];
      Object.keys(value).forEach(coverageCode => {
        if (Object.prototype.hasOwnProperty.call(value, coverageCode)) {
          state.productModelCoverages.push({
            code: coverageCode,
            type: value[coverageCode].type
          });
        }
      });
    }
  }
};
